<template>
  <div>
    <div class="Fuell-Toolbar d-flex justify-content-between">
      <div class="d-flex toolbar-column multiselect-section-selector">
        <span class="multiselect-section-selector-label">{{ $t('export_exportation_flow_using') }}</span>
        <multiselect
          :value="exportationFlowSelected"
          :label="'name'"
          track-by="id"
          :placeholder="$t('export_exportation_flow_using_placeholder')"
          open-direction="bottom"
          :options="exportationFlows"
          :multiple="false"
          :searchable="false"
          :selectLabel="''"
          :selectedLabel="''"
          :deselectLabel="''"
          @select="setExportationFlow($event)"
        >
          <template slot="afterList">
            <li class="Fuell-New-Export--container">
              <span @click="showCreateExportationFlow(true)">
                {{ $t('export_flow_create_export_flow') }}
              </span>
            </li>
          </template>

        </multiselect>
        <span
          class="multiselect-section-selector-link clickable"
          @click="showCreateExportationFlow(false)"
        >{{$t('export_flow_modify')}}</span>
      </div>
      <div class="group-links">
        <router-link
          :to="exportReturnLink()"
          class="Fuell-Tabs--link"
        >
          {{$t('export_flow_export')}}
          <img
            alt="arrow-right"
            :src="require('@/assets/img/icons/icon-arrow-right-double.svg')"
          />
        </router-link>
      </div>
    </div>

    <div>
      <exported-table></exported-table>
    </div>
    <create-exportation-flow-modal
      v-if="showCreateExportationFlowFlag"
      :open.sync="showCreateExportationFlowFlag"
      :exportationFlowId="flowId"
    ></create-exportation-flow-modal>
  </div>
</template>

<script>
import _exportMixins from '../../_mixins/_exportMixins'
import ExportedTable from '../../_components/ExportedTable.vue'

export default {
  name: 'ListExportsIndex',
  mixins: [
    _exportMixins
  ],
  components: {
    ExportedTable
  },
  computed: {
    exportHistory () {
      return this.$store.getters['ExportStore/exportHistory']
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.multiselect-section-selector {
  align-items: center;
  flex: 1;
  .multiselect-section-selector-label {
    font-size: 15px;
    color: var(--text-heading);
  }
  .multiselect {
    max-width: 240px;
    margin: 0 16px;
  }
  .multiselect-section-selector-link {
    font-size: 15px;
    color: var(--blue);
  }
  .Fuell-Button {
    margin: 5px auto 5px;
  }
}
.group-links {
  a {
    display: flex;
    align-items: center;
    line-height: 16px;
    height: 16px;
    img {
      margin-top: 3px;
      margin-left: 5px;
      height: 8px;
    }
  }
}

@media screen and (max-width: 576px) {
  .Fuell-Toolbar {
    flex-direction: column;
    width: 100%;
  }
  .toolbar-column {
    display: flex;
    flex-direction: column;
    width: 100%;
    > * {
      margin: 10px 0px;
    }
  }
  .multiselect-section-selector-label {
    width: 100%;
    display: flex;
    margin: 0px 0px 10px 25px;
    justify-content: center;
  }
  .multiselect-section-selector .multiselect {
    max-width: 100%;
  }
  .Fuell-ToolbarSearch {
    width: 100%;
  }
}
</style>
